import { SET_MODTYPE, CLEAR_MODTYPE } from "../actions/logActions";

const initModType = {
  value: null,
};

const modTypeLogReducer = (state = initModType, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_MODTYPE:
      return {
        ...state,
        value: payload,
      };
    case CLEAR_MODTYPE:
      return { value: null };
    default:
      return state;
  }
};

export default modTypeLogReducer;
